// Vanilla, delegated click handler: clicking an element carrying a `data-print-image`
// attribute opens the referenced image in a new window and triggers the print dialog.
// An optional `data-print-title` is displayed, centered and bold, above the image.
// Delegation on `document` makes it work for dynamically-added (LiveView) content.
export function initPrintImage() {
  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-print-image]");
    if (!trigger) return;

    event.preventDefault();
    printImage(trigger.getAttribute("data-print-image"), trigger.getAttribute("data-print-title"));
  });
}

function printImage(src, title) {
  if (!src) return;

  const printWindow = window.open("", "_blank");
  if (!printWindow) return;

  const safeTitle = title ? escapeHtml(title) : "";
  const heading = safeTitle ? `<h1 style="margin: 0 0 24px; font-size: 1.75rem; font-weight: 700;">${safeTitle}</h1>` : "";

  printWindow.document.write(
    `<div style="text-align: center; font-family: sans-serif;">${heading}<img src="${src}" alt="${safeTitle}" style="max-width: 100%" onload="window.focus(); window.print(); window.close();" /></div>`
  );
  printWindow.document.close();
}

function escapeHtml(text) {
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}
